export default getText => key =>
  ({
    patientReadyAVTitle: getText('A patient is ready for his Audiovisual consult', 'Notifications'),
    patientReadyAVBody1: getText('Patient', 'Notifications'),
    patientReadyAVBody2: getText('is ready to be called.', 'Notifications'),
    patientNewSummaryTitle: getText('A patient just sent a new summary', 'Notifications'),
    patientNewSummaryBody1: getText('Patient', 'Notifications'),
    patientNewSummaryBody2: getText('send a summary about', 'Notifications'),
  }[key])
